import React, { useState, useEffect, useCallback } from 'react';
// import { useSearchParams } from 'react-router-dom';
import Axios, { authHeaders } from '../../../../../utils/axios';
// import { formatMomentDate } from '../../../../../utils/dateHelper';

const LEAD_STATUSES = [
    { label: 'New',         key: 'New',         color: '#007AFF' },
    { label: 'Hot',         key: 'Hot',         color: '#9F2F48' },
    { label: 'Cold',        key: 'Cold',        color: '#FFCC00' },
    { label: 'Medium',      key: 'Medium',      color: '#FF3B30' },
    { label: 'Site Visited',key: 'Site Visited',color: '#FF9500' },
    { label: 'Negotiation', key: 'Negotiation', color: '#008080' },
    { label: 'Token',       key: 'Token',       color: '#007AFF' },
    { label: 'Dastavej',    key: 'Dastavej',    color: '#800000' },
    { label: 'Completed',   key: 'Completed',   color: '#FFCC00' },
    { label: 'Closed',      key: 'Closed',      color: '#FF3B30' },
];

const Dashboard = ({ userId }) => {
    // const [searchParams, setSearchParams] = useSearchParams();

    const [stats, setStats]               = useState(null);
    const [statsLoading, setStatsLoading] = useState(false);

    const fetchDashboardStats = useCallback(async () => {
        if (!userId) return;
        setStatsLoading(true);
        try {
            const response = await Axios.get(`/broker/dashboard`, {
                params: { user_id: userId },
                ...authHeaders(),
            });
            setStats(response.data.data);
        } catch (error) {
            console.error('Failed to fetch dashboard stats:', error);
        } finally {
            setStatsLoading(false);
        }
    }, [userId]);

    useEffect(() => {
        fetchDashboardStats();
    }, [fetchDashboardStats]);

    // const navigateToFollowUps = () => {
    //     const updated = new URLSearchParams(searchParams);
    //     updated.set('broker-tabs', 'followups');
    //     setSearchParams(updated);
    // };

    if (statsLoading) {
        return (
            <div className="d-flex align-items-center justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    const topCards = [
        { label: 'Lands',     value: stats?.total_land_properties ?? 0 },
        { label: 'Properties', value: stats?.total_properties      ?? 0 },
        { label: 'Clients',  value: stats?.total_clients         ?? 0 },
    ];

    // const todayFollowUps = stats?.todayFollowUps || [];

    return (
        <div>
            {/* ── Top stat cards ─────────────────────────────── */}
            <div className="row g-3 mb-4">
                {topCards.map((card, idx) => (
                    <div key={idx} className="col-12 col-md-4">
                        <div
                            className="card p-3 text-center border-0 rounded-3"
                            style={{
                                background:   '#FFF5F5',
                                borderBottom: '3px solid #9F2F48',
                                boxShadow:    '0px 2px 8px rgba(159, 47, 72, 0.06)',
                            }}
                        >
                            <span
                                className="fw-bold"
                                style={{ fontSize: '28px', color: '#9F2F48', display: 'block', lineHeight: '1.2' }}
                            >
                                {String(card.value).padStart(2, '0')}
                            </span>
                            <span
                                className="small mt-1"
                                style={{ fontSize: '13px', fontWeight: 500, color: '#5D596C' }}
                            >
                                {card.label}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            {/* ── Leads (Requirements) ───────────────────────── */}
            <div className="fw-bold mb-3 mt-4 text-dark text-start" style={{ fontSize: '15px' }}>
                Leads{' '}
                <span className="text-secondary fw-normal" style={{ fontSize: '13px' }}>
                    (Requirements)
                </span>
            </div>

            <div className="row g-3 row-cols-2 row-cols-md-5 mb-4">
                {LEAD_STATUSES.map((status, idx) => {
                    const count = stats?.lead_status_counts?.[status.key] ?? 0;
                    return (
                        <div key={idx} className="col">
                            <div
                                className="card p-3 text-center border-0 rounded-3 h-100"
                                style={{
                                    background:  '#FAFAFA',
                                    borderLeft:  `4px solid ${status.color}`,
                                    boxShadow:   '0px 2px 6px rgba(0, 0, 0, 0.02)',
                                }}
                            >
                                <span
                                    className="fw-bold"
                                    style={{ fontSize: '22px', color: status.color, display: 'block', lineHeight: '1.2' }}
                                >
                                    {String(count).padStart(2, '0')}
                                </span>
                                <span
                                    className="small mt-1 text-secondary"
                                    style={{ fontSize: '12px', fontWeight: 500 }}
                                >
                                    {status.label}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* ── Today Follow-ups ───────────────────────────── */}
            {/* <div className="d-flex align-items-center justify-content-between mb-3 mt-4">
                <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '15px' }}>
                    Today Follow-ups
                </h6>
                <button
                    type="button"
                    className="btn btn-link p-0 text-decoration-none small text-primary fw-medium"
                    style={{ fontSize: '13px' }}
                    onClick={navigateToFollowUps}
                >
                    View all
                </button>
            </div>

            <div
                className="card p-4 border rounded-3 position-relative overflow-hidden text-center"
                style={{ minHeight: '180px', background: '#FAFAFA' }}
            >
                {todayFollowUps.length > 0 ? (
                    <div className="d-flex flex-column gap-2 w-100">
                        {todayFollowUps.map((item, idx) => {
                            const title      = item.followup_title || 'Follow-up';
                            const time       = formatMomentDate(item.followup_due_date, 'hh:mm A');
                            const clientName = item.lead?.client?.name || item.property?.client?.name || '—';
                            const desc       = item.notes || '';
                            return (
                                <div
                                    key={idx}
                                    className="d-flex align-items-center justify-content-between p-3 border rounded-3 bg-white w-100 shadow-sm"
                                >
                                    <div className="d-flex flex-column text-start">
                                        <span className="fw-semibold text-dark" style={{ fontSize: '14px' }}>
                                            {title}
                                        </span>
                                        <span className="small text-muted mt-1" style={{ fontSize: '11px' }}>
                                            Client:{' '}
                                            <strong className="text-secondary">{clientName}</strong>
                                        </span>
                                        {desc && (
                                            <span className="small text-secondary mt-1" style={{ fontSize: '12px' }}>
                                                {desc}
                                            </span>
                                        )}
                                    </div>
                                    <span
                                        className="badge bg-light text-primary border rounded-pill px-3 py-2 small fw-semibold"
                                        style={{ fontSize: '11px' }}
                                    >
                                        {time}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center w-100 py-2">
                        <svg
                            width="180"
                            height="110"
                            viewBox="0 0 220 150"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect x="50"  y="20" width="120" height="90" rx="6" fill="#F8F9FA" stroke="#E9ECEF" strokeWidth="2" />
                            <rect x="50"  y="20" width="120" height="15" rx="6" fill="#E9ECEF" />
                            <circle cx="60" cy="27" r="3" fill="#FF5F56" />
                            <circle cx="68" cy="27" r="3" fill="#FFBD2E" />
                            <circle cx="76" cy="27" r="3" fill="#27C93F" />

                            <path d="M40 130C40 115 50 110 60 110C70 110 80 115 80 130" fill="#9F2F48" opacity="0.8" />
                            <circle cx="60" cy="95" r="12" fill="#FAD0C4" />
                            <path d="M50 90C50 85 55 83 60 83C65 83 70 85 70 90C70 91 60 88 50 90Z" fill="#2D3748" />

                            <path d="M140 130C140 115 150 110 160 110C170 110 180 115 180 130" fill="#2B6CB0" opacity="0.8" />
                            <circle cx="160" cy="95" r="12" fill="#FEEBC8" />
                            <path d="M148 95C148 85 152 82 160 82C168 82 172 85 172 95C172 100 160 98 148 95Z" fill="#1A202C" />

                            <rect x="35"  y="45" width="55" height="25" rx="12" fill="#E2E8F0" />
                            <path d="M75 70L80 78L83 70" fill="#E2E8F0" />
                            <rect x="45"  y="52" width="35" height="4" rx="2" fill="#CBD5E0" />
                            <rect x="45"  y="60" width="20" height="4" rx="2" fill="#CBD5E0" />

                            <rect x="125" y="45" width="55" height="25" rx="12" fill="#FED7D7" />
                            <path d="M145 70L140 78L137 70" fill="#FED7D7" />
                            <rect x="135" y="52" width="35" height="4" rx="2" fill="#E53E3E" opacity="0.4" />
                            <rect x="135" y="60" width="25" height="4" rx="2" fill="#E53E3E" opacity="0.4" />
                        </svg>
                        <span className="text-secondary small mt-2 fw-medium" style={{ fontSize: '13px' }}>
                            No follow-ups today
                        </span>
                    </div>
                )}
            </div> */}
        </div>
    );
};

export default Dashboard;
